import {
  AlbumArt,
  BrandColors,
  Caption,
  convertToSlug,
  ExternalLink,
  MediaQueries,
  Opacities,
  rem,
  Row,
} from '@collabhouse/shared'
import styled, { css } from 'styled-components'

export const getTitle = (name: string, version?: string): string => (version ? `${name} - ${version}` : name)

export const getAudioFilename = (name: string, version?: string): string => convertToSlug(getTitle(name, version))

export const getFormattedBpm = (bpm: number): string => {
  if (!bpm) {
    return null
  }

  return `${bpm} BPM`
}

export const formatTime = (seconds: number): string => {
  if (!seconds) {
    return '0:00'
  }

  const m = Math.floor(seconds / 60)
  const s = Math.floor((seconds % 3600) % 60)

  return `${m}:${`0${s}`.slice(-2)}`
}

export const getFormattedArtists = (
  artists: Array<{
    artist: { name?: string }
    position: number
    primary: boolean
  }>,
): string => {
  const primaryArtists = artists
    ?.filter((data) => data.primary && data.artist.name)
    .sort((a, b) => a.position - b.position)
    .map((data) => data.artist.name)
    .join(', ')

  const featuringArtists = artists
    ?.filter((data) => !data.primary && data.artist.name)
    .sort((a, b) => a.position - b.position)
    .map((data) => data.artist.name)
    .join(', ')

  return `${primaryArtists} ${featuringArtists && `featuring ${featuringArtists}`} `
}

export const Wrapper = styled(Row)<{ disabled?: boolean; isPlaying?: boolean }>(
  ({ disabled, isPlaying }) => css`
    padding: ${rem(12)} ${rem(20)};
    cursor: pointer;
    outline: 1px solid transparent;
    outline-offset: ${rem(3)};
    background-color: ${BrandColors.steelGray.toString()};

    :hover {
      background: ${BrandColors.white.alpha(Opacities.twenty).toString()};
    }
    :focus {
      background: ${BrandColors.darkBlue.toString()};
    }

    :active {
      background: ${BrandColors.darkBlue.toString()};
    }

    ${disabled &&
    css`
      pointer-events: none;
      opacity: ${Opacities.thirtyfive.toString()};
    `}

    ${isPlaying && `background: ${BrandColors.darkBlue.toString()};`}

    ${MediaQueries.desktop} {
      padding: ${rem(12)} ${rem(16)};
    }
  `,
)

export const Image = styled(AlbumArt)`
  position: absolute;
`

export const Text = styled(Caption)`
  color: ${BrandColors.white.toString()};
`

export const PlatformChip = styled(ExternalLink)`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: ${rem(12)};
  border: 1px solid ${BrandColors.white.alpha(Opacities.twenty).toString()};
  background-image: none;
`
